import { render, staticRenderFns } from "./IncluirVenda.vue?vue&type=template&id=6e068579&scoped=true"
import script from "./IncluirVenda.vue?vue&type=script&lang=js"
export * from "./IncluirVenda.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e068579",
  null
  
)

export default component.exports